module.exports = __webpack_public_path__ + "img/service2.ecbea8df.svg";